import scriptLoader from 'react-async-script-loader'

import { compose, defaultProps, withPropsOnChange } from 'recompose'
import AutocompleteService = google.maps.places.AutocompleteService
import PlacesServiceStatus = google.maps.places.PlacesServiceStatus
import PlacesService = google.maps.places.PlacesService

declare global {
  interface Window {
    google: any
  }
}

interface Props {
  autoComplete: AutocompleteService
  okStatus: PlacesServiceStatus
  placesService: PlacesService
}

const withGooglePlaces = compose<Props, {}>(
  scriptLoader([
    `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_KEY}&libraries=places`,
  ]),
  defaultProps({
    isScriptLoaded: false,
  }),
  withPropsOnChange(['isScriptLoaded'], ({ isScriptLoaded }) => {
    let props = {}
    if (isScriptLoaded) {
      props = {
        autoComplete: new window.google.maps.places.AutocompleteService(),
        okStatus: window.google.maps.places.PlacesServiceStatus.OK,
        placesService: new window.google.maps.places.PlacesService(
          document.createElement('div'),
        ),
      }
    }
    return props
  }),
)

export default withGooglePlaces
